import React, { useState, useEffect } from 'react';
import { Box, AppBar, Toolbar, Typography, Container } from '@mui/material';
import { useSettings } from '@/context/SettingsContext';
import { WebSocketProvider } from '@/context/WebSocketContext';
import { audioService } from '@/services/audioService';
import SettingsSelector from './SettingsSelector';
import ChatInterface from './ChatInterface';
import StartScreen from './StartScreen';

const AppLayout: React.FC = () => {
  const { language } = useSettings();
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [hasStarted, setHasStarted] = useState(false);

  const translations = {
    en: {
      title: 'Crux Conversational AI',
      subtitle: '',
    },
    ar: {
      title: 'كروكس للذكاء الاصطناعي التفاعلي',
      subtitle: '',
    },
  };

  const t = translations[language];

  // Get token from URL (no fallback)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    setSessionId(urlToken || '');
  }, []);

  const handleStart = () => {
    setHasStarted(true);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppBar position="static" elevation={1}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" component="div">
              {t.title}
            </Typography>
            <Typography variant="caption" component="div" sx={{ opacity: 0.8 }}>
              {t.subtitle}
            </Typography>
          </Box>
          <SettingsSelector />
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="lg"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          py: 3,
          overflow: 'hidden',
        }}
      >
        {sessionId !== null ? (
          !hasStarted ? (
            <StartScreen onStart={handleStart} token={sessionId} />
          ) : (
            <WebSocketProvider token={sessionId}>
              <ChatInterface />
            </WebSocketProvider>
          )
        ) : null}
      </Container>
    </Box>
  );
};

export default AppLayout;
